import BoxError from './boxError.component';

export default BoxError